import {FC, ReactNode} from 'react'

import {HeaderAuthAction} from '@/components/header/HeaderAuthAction'
import {HeaderMainButton, HeaderMainButtonProps} from '@/components/header/HeaderMainButton'
import {HeaderNavigationLabel} from '@/components/header/HeaderNavigationLabel'
import {HeaderLogoResponsive} from '@/components/header/logo/HeaderLogoResponsive'
import {HelpCenterButton} from '@/components/help-center/HelpCenterButton'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Header} from '../../header/Header'

type KnowledgeBaseHeaderProps = {
  title: string
  searchInput?: ReactNode
  isMobileNavigationActive: boolean
  setMobileNavigationActive: (value: boolean) => void
  mobileNavigation: ReactNode
  mainCtaButton?: HeaderMainButtonProps
}

export const KnowledgeBaseHeader: FC<KnowledgeBaseHeaderProps> = ({
  title,
  searchInput,
  isMobileNavigationActive,
  setMobileNavigationActive,
  mobileNavigation,
  mainCtaButton,
}) => {
  return (
    <>
      <Header
        isOverlayVisible={isMobileNavigationActive}
        onOverlayClose={() => setMobileNavigationActive(false)}
      >
        <div className="wrapper content">
          <div className="wrapper navigation">
            <HeaderLogoResponsive mainCtaButton={mainCtaButton} />
            <div className="desktop">
              <HeaderNavigationLabel label={title} />
            </div>
          </div>
          <div className="wrapper items">
            {searchInput && <div className="desktop">{searchInput}</div>}
            <div className="desktop">
              <HelpCenterButton />
            </div>
            <HeaderAuthAction />
            {mainCtaButton && (
              <div className="desktop">
                <HeaderMainButton {...mainCtaButton} />
              </div>
            )}
            {mobileNavigation}
          </div>
        </div>
      </Header>

      <style jsx>{`
        .content {
          justify-content: space-between;
          width: 100%;
          gap: ${theme.spacing[2]};
        }
        .wrapper {
          display: flex;
          align-items: center;
        }
        .items {
          gap: ${theme.spacing[2]};
        }
        @media ${TABLET_SCREENSIZE} {
          .desktop {
            display: none;
          }
          .navigation {
            overflow: hidden;
            padding-left: ${theme.spacing[3.5]};
          }
          .items {
            padding: ${theme.spacing[3.5]};
            padding-left: 0;
          }
        }
      `}</style>
    </>
  )
}
